import * as SC from './LoadingStyle';

import { Loader } from '@/atoms/Loader/Loader';
import * as GSC from '@/styles/GlobalStyles';

export const Loading = () => {
  return (
    <GSC.PageWrapper>
      <SC.Container>
        <SC.Center>
          <Loader />
        </SC.Center>
      </SC.Container>
    </GSC.PageWrapper>
  );
};
